import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";

import WithAppLayout from "../../../components/WithAppLayout";
import PageTableWithSearch from "../../../components/PageTableWithSearch/PageTableWithSearch";
import JobContactEmailFilter from "../../../components/JobContactEmailFilter";

import { activeJobsColumns } from "../../../components/PageTableWithSearch/tableDataHelper";
import { ACTIVE_JOBS_QUERY } from "../../../graphql/jobs";
import { JOB_DETAILS_PATH } from "../../../routes";
import { useHistoryState } from "../../../helpers/hooks";
import __ from "../../../helpers/translations"

const initialSort = [
  {
    id: "approvedByClientCount",
    desc: true,
  },
  {
    id: "interestedCount",
    desc: true,
  },
];

function ActiveJobsPage({ currentUser }) {
  const navigate = useNavigate();

  const [initialFilter, setInitialFilter] = useHistoryState("filter", null);
  const [contactEmail, setContactEmail] = useState(null);

  // The contact filter runs on the server; the search box still narrows the
  // returned rows on the client.
  const { data, loading } = useQuery(ACTIVE_JOBS_QUERY, {
    variables: { contactEmail: contactEmail || null },
    fetchPolicy: "network-only",
  });

  const agencyType = currentUser?.agency?.type;
  const jobs = data?.agencyActiveJobs || [];

  return (
    <PageTableWithSearch
      title={`${__("Active", agencyType)} Jobs ${
        jobs.length ? ` (${jobs.length})` : ""
      }`}
      tableId="agency-active-jobs"
      initialValue={initialFilter}
      columns={activeJobsColumns}
      data={jobs}
      loading={loading}
      filterControls={
        <JobContactEmailFilter
          value={contactEmail}
          onChange={setContactEmail}
          currentUserEmail={currentUser?.email}
        />
      }
      onClickRow={(moblyzeJob, search) => {
        // set current page state to the current search filter
        if (search && search !== "") {
          setInitialFilter(search);
        }

        navigate(JOB_DETAILS_PATH.replace(":id", moblyzeJob.id));
      }}
      initialSort={initialSort}
    />
  );
}

export default WithAppLayout(ActiveJobsPage);
